export default __webpack_public_path__ + "static/media/evenshot.03b73d92.png";